import orderBy from 'lodash/orderBy'
import { computed, makeObservable } from 'mobx'

import { Shift } from 'modules/shift_management/lib/types'
import UnassignedShift, {
  TUnassignedShift,
} from 'modules/shift_management/store/internal/models/UnassignedShift'

class UnassignedShifts {
  unassignedShifts: UnassignedShift[]

  constructor(unassignedShifts: UnassignedShift[]) {
    this.unassignedShifts = unassignedShifts

    makeObservable(this, {
      all: computed,
    })
  }

  static buildFromGraphQL(unassignedShifts: TUnassignedShift[]): UnassignedShifts {
    const unassignedShiftObjects = unassignedShifts.map((unassignedShift) => {
      return UnassignedShift.buildFromGraphQL(unassignedShift)
    })

    return new UnassignedShifts(unassignedShiftObjects)
  }

  get all(): UnassignedShift[] {
    return this.unassignedShifts
  }

  filterByDate(date: moment.Moment): UnassignedShift[] {
    return this.unassignedShifts.filter((unassignedShift) => unassignedShift.isDate(date))
  }

  filterByDateAndNotEmptyCounter(date: moment.Moment, shifts: Shift[]): UnassignedShift[] {
    return this.unassignedShifts.filter(
      (unassignedShift) =>
        unassignedShift.isDate(date) && unassignedShift.currentCounter(shifts) !== 0
    )
  }

  filterByDateAndEmptyCounter(date: moment.Moment, shifts: Shift[]): UnassignedShift[] {
    return this.unassignedShifts.filter(
      (unassignedShift) =>
        unassignedShift.isDate(date) && unassignedShift.currentCounter(shifts) === 0
    )
  }

  orderedByDateAndCounter(date: moment.Moment, shifts: Shift[]): UnassignedShift[] {
    const finalList: UnassignedShift[] = []

    const notEmpty = orderBy(
      this.filterByDateAndNotEmptyCounter(date, shifts),
      ['locationId', 'startAt'],
      ['asc', 'asc']
    )
    const empty = orderBy(
      this.filterByDateAndEmptyCounter(date, shifts),
      ['locationId', 'startAt'],
      ['asc', 'asc']
    )

    finalList.push(...notEmpty, ...empty)

    return finalList
  }
}

export default UnassignedShifts
